import React, { useEffect, useState } from "react";
import "./FilterTable.css"; //Styling
//Utility
import { convertRuntime } from "../../../utility/utility.js";
//Redux
import { useSelector, useDispatch } from "react-redux";
import { modifyFilterList } from "../../../page/FilterPage/FilterSlice.js";
import { getFilterResult } from "../../../page/FilterPage/FilterSlice.js";
//Child Comp
import { FilterSectionCollapse } from "./FilterSectionCollapse.js";
import { GenreFilter } from "./GenreFilter.js";
import { KeywordFilter } from "./KeywordFilter.js";
import { RuntimeFilter } from "./RuntimeFilter.js";
import { RegionFilter } from "./RegionFilter.js";
import { PeriodFilter } from "./PeriodFilter.js";

export const FilterTable = (props) => {
  const { genresList, setShowFilter } = props;
  const [filterType, setFilterType] = useState(0);
  let genreList = genresList[filterType];
  const [focusSection, setFocusSection] = useState("");

  let filterList = useSelector((state) => state.filter.filterList);
  //Update Filter Result
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getFilterResult(filterList));
  }, [filterList]);

  //Update Genre Type (Mov or Tv)
  function handleTypeSwitch() {
    if (filterType == 0) {
      setFilterType(1);
    } else {
      setFilterType(0);
    }
  }
  useEffect(() => {
    dispatch(
      modifyFilterList({
        field: "type",
        payload: filterType,
      })
    );
    dispatch(
      modifyFilterList({
        field: "page",
        payload: 1,
      })
    );
  }, [filterType]);

  //Update Focus Section
  function handleCollapse(event) {
    let btn_element = event.target;
    if (!btn_element.className.includes("btn_active")) {
      let filter_name = btn_element.className.split(" ")[0];
      setFocusSection(filter_name);
      console.log(btn_element.className + " OPEN");
    } else {
      setFocusSection("");
      console.log(btn_element.className + " CLOSE");
    }
  }

  return (
    <div className="filter_table_wrapper">
      <div className="filter_table_upper">
        <div className="filter_table_type">
          <div
            className={`filter_table_type mov_opt ${
              filterType == 0 ? "active" : ""
            }`}
            onClick={handleTypeSwitch}
          >
            Movies
          </div>
          <div
            className={`filter_table_type tv_opt ${
              filterType == 1 ? "active" : ""
            }`}
            onClick={handleTypeSwitch}
          >
            TV Shows/Series
          </div>
        </div>
        <div
          className="filter_table_show_filter"
          onClick={() => setShowFilter(false)}
        >
          Go when you're ready!
        </div>
      </div>
      <div className="filter_table_content_wrapper">
        <div className="filter_table_content genre_filter_container">
          <FilterSectionCollapse
            sectionName="genre"
            focusSection={focusSection}
            handleCollapse={handleCollapse}
          />

          <GenreFilter
            genreList={genreList}
            className={"genre_filter_wrapper"}
            focusSection={focusSection}
          />
        </div>
        <div className="filter_table_content keyword_filter_container">
          <FilterSectionCollapse
            sectionName="keyword"
            focusSection={focusSection}
            handleCollapse={handleCollapse}
          />
          <KeywordFilter
            genreList={genreList}
            className={"keyword_filter_wrapper"}
            focusSection={focusSection}
          />
        </div>
        <div className="filter_table_content runtime_filter_container">
          <FilterSectionCollapse
            sectionName="runtime"
            focusSection={focusSection}
            handleCollapse={handleCollapse}
          />
          <RuntimeFilter
            genreList={genreList}
            className={"runtime_filter_wrapper"}
            focusSection={focusSection}
          />
        </div>
        <div className="filter_table_content region_filter_container">
          <FilterSectionCollapse
            sectionName="region"
            focusSection={focusSection}
            handleCollapse={handleCollapse}
          />
          <RegionFilter
            genreList={genreList}
            className={"region_filter_wrapper"}
            focusSection={focusSection}
          />
        </div>
        <div className="filter_table_content period_filter_container">
          <FilterSectionCollapse
            sectionName="period"
            focusSection={focusSection}
            handleCollapse={handleCollapse}
          />
          <PeriodFilter
            genreList={genreList}
            className={"period_filter_wrapper"}
            focusSection={focusSection}
          />
        </div>
      </div>
    </div>
  );
};
